import { render, staticRenderFns } from "./editSegmentBase.vue?vue&type=template&id=02b4e5e2&"
import script from "./editSegmentBase.vue?vue&type=script&lang=js&"
export * from "./editSegmentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports